"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/SteeringWheel2.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SteeringWheel2 = function SteeringWheel2(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 257.01 241.47"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Steering Wheel Icon"), _react2.default.createElement("path", {
    className: "steering-wheel",
    d: "M123.57 0a128.5 128.5 0 0 0-68 234.22 41 41 0 0 0 23.26 7.24h99.27a41 41 0 0 0 23.26-7.24A128.5 128.5 0 0 0 133.44 0h-9.86zm4.85 20.45a6 6 0 0 0 .83 0 109.16 109.16 0 0 1 104.87 80.37 4.78 4.78 0 0 1-4.61 6H28.17a4.78 4.78 0 0 1-4.61-6 109.16 109.16 0 0 1 104.87-80.36zm-103 118.88a4.71 4.71 0 0 1 1.21.13A114.89 114.89 0 0 1 109 215.3a4.79 4.79 0 0 1-4.54 6.28H73.55a11.64 11.64 0 0 1-6.62-2.06 109.15 109.15 0 0 1-46.18-74.74 4.79 4.79 0 0 1 4.64-5.44zm206.93 0a4.79 4.79 0 0 1 4.64 5.44 109.15 109.15 0 0 1-46.18 74.74 11.66 11.66 0 0 1-6.62 2.06h-30.9a4.79 4.79 0 0 1-4.54-6.28 114.89 114.89 0 0 1 82.39-75.83 4.75 4.75 0 0 1 1.21-.13zm0 0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = SteeringWheel2;